import React from 'react';
import { FormGroup, Label, Input, FormFeedback } from 'reactstrap';
import ErrorList from './ErrorList';
import { idGenerator } from '~/lib/helper/IdHelper';

const nextId = idGenerator('acknowledgementAlert');

type AcknowledgementAlertProps = {
    warning: React.ReactNode;
    label: React.ReactNode;
    confirmed: boolean;
    onConfirmedChange: (confirmed: boolean) => unknown;
    errors?: string[];
    className?: string;
};

// Warning callout with a required "I understand…" checkbox, gating an irreversible action on explicit
// consent. role="alert" sits on the warning text span alone, so the consequence is announced when it
// appears — not on a wrapping reactstrap <Alert>, whose role="alert" would enclose this checkbox and the
// checkbox's own role="alert" ErrorList (nesting live regions); a sibling span keeps both alerts flat.
// aria-describedby also ties the warning to the checkbox for its description on focus.
export default class AcknowledgementAlert extends React.Component<AcknowledgementAlertProps> {
    private readonly baseId = nextId();

    render() {
        const { warning, label, confirmed, onConfirmedChange, errors, className } = this.props;
        const warningId = `${this.baseId}Warning`;
        const checkboxId = `${this.baseId}Check`;
        return (
            <div className={className ? `alert alert-warning ${className}` : 'alert alert-warning'}>
                <span id={warningId} role="alert">
                    {warning}
                </span>
                <FormGroup check className="mt-2 mb-0">
                    <Input
                        id={checkboxId}
                        type="checkbox"
                        checked={confirmed}
                        onChange={(e) => onConfirmedChange(e.target.checked)}
                        invalid={(errors?.length ?? 0) > 0}
                        aria-describedby={warningId}
                    />
                    <Label check for={checkboxId}>
                        {label}
                    </Label>
                    <FormFeedback>
                        <ErrorList errors={errors} />
                    </FormFeedback>
                </FormGroup>
            </div>
        );
    }
}
